<div #productsPage data-section-id="products-page-section" data-section-name="Products Page">
  <app-products-hero></app-products-hero>
  <app-products-overview></app-products-overview>
  <app-how-to-apply></app-how-to-apply>
  <app-product-cards></app-product-cards>

  <!-- <app-apply-banner></app-apply-banner> -->
   <app-cta-banner></app-cta-banner>
</div>

<!-- Botones flotantes reutilizables -->
<app-floating-buttons></app-floating-buttons>
